export let layersOfImportance: string[] = [
  "LVWR:LINE-DEENERGIZED",
  "LVWR:LINE-PHASE-A",
  "LVWR:LINE-PHASE-B",
  "LVWR:LINE-PHASE-C",
  "LVWR:LOAD",
  "LVWR:DEVICES-ABC",
  "LVWR:DEVICES-AB",
  "LVWR:DEVICES-AC",
  "LVWR:DEVICES-BC",
  "LVWR:DEVICES-A",
  "LVWR:DEVICES-B",
  "LVWR:DEVICES-C",
  "LVWR:Transformers-ABC",
  "LVWR:Transformers-AB",
  "LVWR:Transformers-BC",
  "LVWR:Transformers-AC",
  "LVWR:Transformers-A",
  "LVWR:Transformers-B",
  "LVWR:Transformers-C",
  "LVWR:DEVICES-DENERGIZED",
  "LVWR:DEVICES-UNENERGIZED",
  "LVWR:DEVICES-SOURCE",
  "LVWR:ADJUNCT",
  //"LVWR:Flow-Direction",
];
